// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Product Section - RoundIconButton Option Bar Responsive Overrides */

/* ==========================================
   Responsive Design - 1440px
   ========================================== */
@media screen and (max-width: 1440px) {
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar {
    max-width: 600px;
    right: 80px;
  }

  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels {
    max-width: 600px;
  }
}

/* ==========================================
   Responsive Design - 1280px
   ========================================== */
@media screen and (max-width: 1280px) {
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar {
    max-width: 500px;
    right: 110px;
    top: 50px;
  }

  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels {
    max-width: 500px;
    height: auto;
  }

  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-item.with-label {
    min-width: 140px;
    padding: 10px 12px;
  }
}

/* ==========================================
   Responsive Design - 850px
   ========================================== */
@media screen and (max-width: 850px) {
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar {
    top: 10px !important;
  }
}
@media screen and (max-width: 500px) {
  /* Options Bar - Icon Only variant (min 3 items per row) */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar {
    width: 350px;
    max-width: 350px;
    height: auto;
    padding: 8px 0px;
    gap: 5px;
    border-radius: 30px;
    right: 50%;
    transform: translateX(50%);
    top: 80px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar::before {
    border-radius: 30px;
  }

  /* Inner container - allows 3 items per row for icon only */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-inner {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 3px;
    gap: 0px;
    width: 350px;
  }

  /* Options rows wrapper - flatten for mobile */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-multi-row {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    width: 350px;
    padding: 0;
    gap: 0px;
  }

  /* Make inner containers display:contents to flatten structure */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-multi-row .scl--web-component-round-icon-button-options-inner {
    display: contents;
  }

  /* Hide dividers on mobile */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-divider {
    display: none;
  }

  /* Individual option item pill - icon only (116px = 3 per 350px row) */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-item {
    padding: 10px 15px;
    max-width: 116px;
    min-height: 46px;
    gap: 24px;
    border-radius: 50px;
    box-sizing: border-box;
    flex: 0 0 116px;
  }

  /* Icon container */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-icon {
    width: 43px;
    height: 27px;
  }

  /* ==========================================
     Icon + Label variant - 440px (min 2 items per row)
     ========================================== */

  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels {
    width: 350px;
    max-width: 350px;
    height: auto;
    padding: 19px 10px;
    gap: 5px;
    border-radius: 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  /* Inner container - allows 2 items per row for icon+label */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels .scl--web-component-round-icon-button-options-inner {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    padding: 0px;
    gap: 5px;
    width: 340px;
  }

  /* Option item pill with label (165px = 2 per 340px row with 5px gap) */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-item.with-label {
    padding: 12px 15px;
    min-width: 165px;
    width: 165px;
    max-width: 165px;
    max-height: 50px;
    border-radius: 50px;
    box-sizing: border-box;
    flex: 0 0 165px;
  }

  /* Icon + label row wrapper - 440px */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-icon-label {
    gap: 9px;
  }

  /* Icon size in icon+label variant - 440px */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-icon {
    width: 26px;
    height: 26px;
  }

  /* Label in icon+label variant - 440px */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-label {
    font-size: 16px;
    line-height: 16px;
    white-space: nowrap;
  }

  /* ==========================================
     Multi-row variant - 440px
     ========================================== */

  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.multi-row {
    width: 350px;
    max-width: 350px;
    height: auto;
    border-radius: 30px;
  }

  /* Icon + Label multi-row */
  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels.multi-row .scl--web-component-round-icon-button-options-multi-row {
    width: 340px;
    gap: 5px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/page-module/page-services/product/css/productRoundIconButton.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;;+CAE+C;AAC/C;EACE;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;+CAE+C;AAC/C;EACE;IACE,gBAAgB;IAChB,YAAY;IACZ,SAAS;EACX;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;AACF;;AAEA;;+CAE+C;AAC/C;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,0DAA0D;EAC1D;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,QAAQ;IACR,mBAAmB;IACnB,UAAU;IACV,0BAA0B;IAC1B,SAAS;IACT,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA,2DAA2D;EAC3D;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,YAAY;EACd;;EAEA,8CAA8C;EAC9C;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,UAAU;IACV,QAAQ;EACV;;EAEA,gEAAgE;EAChE;IACE,iBAAiB;EACnB;;EAEA,4BAA4B;EAC5B;IACE,aAAa;EACf;;EAEA,sEAAsE;EACtE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;IACT,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;EACjB;;EAEA,mBAAmB;EACnB;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;iDAE+C;;EAE/C;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,4DAA4D;EAC5D;IACE,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,QAAQ;IACR,YAAY;EACd;;EAEA,uEAAuE;EACvE;IACE,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;EACjB;;EAEA,qCAAqC;EACrC;IACE,QAAQ;EACV;;EAEA,4CAA4C;EAC5C;IACE,WAAW;IACX,YAAY;EACd;;EAEA,wCAAwC;EACxC;IACE,eAAe;IACf,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;;iDAE+C;;EAE/C;IACE,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;EACrB;;EAEA,2BAA2B;EAC3B;IACE,YAAY;IACZ,QAAQ;EACV;AACF","sourcesContent":["/* Product Section - RoundIconButton Option Bar Responsive Overrides */\n\n/* ==========================================\n   Responsive Design - 1440px\n   ========================================== */\n@media screen and (max-width: 1440px) {\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar {\n    max-width: 600px;\n    right: 80px;\n  }\n\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels {\n    max-width: 600px;\n  }\n}\n\n/* ==========================================\n   Responsive Design - 1280px\n   ========================================== */\n@media screen and (max-width: 1280px) {\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar {\n    max-width: 500px;\n    right: 110px;\n    top: 50px;\n  }\n\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels {\n    max-width: 500px;\n    height: auto;\n  }\n\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-item.with-label {\n    min-width: 140px;\n    padding: 10px 12px;\n  }\n}\n\n/* ==========================================\n   Responsive Design - 850px\n   ========================================== */\n@media screen and (max-width: 850px) {\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar {\n    top: 10px !important;\n  }\n}\n@media screen and (max-width: 500px) {\n  /* Options Bar - Icon Only variant (min 3 items per row) */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar {\n    width: 350px;\n    max-width: 350px;\n    height: auto;\n    padding: 8px 0px;\n    gap: 5px;\n    border-radius: 30px;\n    right: 50%;\n    transform: translateX(50%);\n    top: 80px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar::before {\n    border-radius: 30px;\n  }\n\n  /* Inner container - allows 3 items per row for icon only */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-inner {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    padding: 3px;\n    gap: 0px;\n    width: 350px;\n  }\n\n  /* Options rows wrapper - flatten for mobile */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-multi-row {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    width: 350px;\n    padding: 0;\n    gap: 0px;\n  }\n\n  /* Make inner containers display:contents to flatten structure */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-multi-row .scl--web-component-round-icon-button-options-inner {\n    display: contents;\n  }\n\n  /* Hide dividers on mobile */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-divider {\n    display: none;\n  }\n\n  /* Individual option item pill - icon only (116px = 3 per 350px row) */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-item {\n    padding: 10px 15px;\n    max-width: 116px;\n    min-height: 46px;\n    gap: 24px;\n    border-radius: 50px;\n    box-sizing: border-box;\n    flex: 0 0 116px;\n  }\n\n  /* Icon container */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-icon {\n    width: 43px;\n    height: 27px;\n  }\n\n  /* ==========================================\n     Icon + Label variant - 440px (min 2 items per row)\n     ========================================== */\n\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels {\n    width: 350px;\n    max-width: 350px;\n    height: auto;\n    padding: 19px 10px;\n    gap: 5px;\n    border-radius: 30px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n  }\n\n  /* Inner container - allows 2 items per row for icon+label */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels .scl--web-component-round-icon-button-options-inner {\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n    padding: 0px;\n    gap: 5px;\n    width: 340px;\n  }\n\n  /* Option item pill with label (165px = 2 per 340px row with 5px gap) */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-item.with-label {\n    padding: 12px 15px;\n    min-width: 165px;\n    width: 165px;\n    max-width: 165px;\n    max-height: 50px;\n    border-radius: 50px;\n    box-sizing: border-box;\n    flex: 0 0 165px;\n  }\n\n  /* Icon + label row wrapper - 440px */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-icon-label {\n    gap: 9px;\n  }\n\n  /* Icon size in icon+label variant - 440px */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-icon {\n    width: 26px;\n    height: 26px;\n  }\n\n  /* Label in icon+label variant - 440px */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-option-icon-label .scl--web-component-round-icon-button-option-label {\n    font-size: 16px;\n    line-height: 16px;\n    white-space: nowrap;\n  }\n\n  /* ==========================================\n     Multi-row variant - 440px\n     ========================================== */\n\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.multi-row {\n    width: 350px;\n    max-width: 350px;\n    height: auto;\n    border-radius: 30px;\n  }\n\n  /* Icon + Label multi-row */\n  .scl--web-page-product-image-icon-button .scl--web-component-round-icon-button-options-bar.has-labels.multi-row .scl--web-component-round-icon-button-options-multi-row {\n    width: 340px;\n    gap: 5px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
